import state from './modulePaymentChannelState.js'
import mutations from './modulePaymentChannelMutations.js'
import actions from './modulePaymentChannelActions.js'
import getters from './modulePaymentChannelGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

